import { useState } from 'react';
import styles from './Tabs.module.css';
import { useTheme } from '../../hooks/useTheme';
import { useAuth } from '../../hooks/AuthProvider';
import UserManagement from './user-management/UserManagement';
import Notifications from './notifications/Notifications';
import { Tab, Tabs } from '@dsi/react-eds';
import Retention from './retention/Retention';
import TraceHuntConfig from './tracehunt-config/TraceHuntConfig';
import { IS_SHOW_TRACEHUNT } from '../../config';
import { AiSettingsTab } from '../AiChat/AiSettingsTab';

function Settings() {
  const { theme } = useTheme();
  const { hasRole } = useAuth();
  const [selectedTab, setSelectedTab] = useState(0);
  
  const isAdmin = hasRole('admin');
  const showTraceHunt = IS_SHOW_TRACEHUNT === 'true' && isAdmin;

  const handleTabChange = (_: React.SyntheticEvent, activeTab: number) => {
    setSelectedTab(activeTab);
  };

  return (
    <div className={`${theme ? 'light-theme' : 'dark-theme'}`}>
      <div className={`${styles['tabs']} settings-container`}>
        <Tabs activeTab={selectedTab} onTabChange={handleTabChange}>
          <Tab title="User Management" selected>
            {selectedTab === 0 ? <UserManagement activeTab={selectedTab} /> : <></>}
          </Tab>
          <Tab title="SMTP">{selectedTab === 1 ? <Notifications /> : <></>}</Tab>
          <Tab title="Housekeeping">{selectedTab === 2 ? <Retention /> : <></>}</Tab>
          <Tab title="AI Assistant">{selectedTab === 3 ? <AiSettingsTab /> : <></>}</Tab>
          {
            showTraceHunt ? (
              <Tab title="TraceHunt">{selectedTab === 4 ? <TraceHuntConfig /> : <></>}</Tab>
            ) : (
              (null as unknown as React.ReactElement)
            ) /* EDS Tabs requires ReactElement children; null renders nothing */
          }
        </Tabs>
      </div>
    </div>
  );
}
export default Settings;
